import { Dropdown } from "antd";
import { useState } from "react";

function TableHeaderSorting({
  options,
  onChange,
  defaultOptionKey = "NEWEST",
}) {
  const [sortBy, setSortBy] = useState("Newest");

  const items = options.map((option) => ({
    key: option.key,
    label: (
      <div
        className={`w-[80px] px-4 py-[5px] cursor-pointer ${
          sortBy === option.label ? "bg-[#572D86] text-white rounded-md" : ""
        }`}
        onClick={() => {
          setSortBy(option.label);
          onChange(option.key);
        }}
      >
        {option.label}
      </div>
    ),
  }));

  return (
    <div className="flex flex-row items-center mx-[40px]">
      <div className="font-uregular mx-[8px] text-md whitespace-nowrap">
        Sort By
      </div>
      <Dropdown
        menu={{ items }}
        placement="bottomRight"
        trigger={["click"]}
      >
        <div className="flex items-center cursor-pointer space-x-1">
          <div className="font-ubold text-md mx-[8px] text-start w-[72px]">
            {sortBy}
          </div>
          <img className="w-[12px] h-[12px]" src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/chevron.svg"} />
        </div>
      </Dropdown>
    </div>
  );
}

export default TableHeaderSorting;
